module.exports = __webpack_public_path__ + "img/9.ecb07afa.jpg";